<template>
    <div class="joinMessage">
        <p><span>职位名称</span>{{jobItem.title}}</p>
        <p><span>所属部门</span>{{jobItem.company}}</p>
        <p><span>投递状态</span>{{timestampToTime(jobItem.post_time)}}</p>
        <p><span>状&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;态</span><i>{{jobItem.already_read}}</i></p>
    </div>
</template>

<script>
    export default {
        name: "joinMessage",
        props:["jobItem"],
        methods: {
            timestampToTime: function (timestamp) {
                var date = new Date(timestamp * 1000);//时间戳为10位需*1000，时间戳为13位的话不需乘1000
                var Y = date.getFullYear() + '-';
                var M = (date.getMonth()+1 < 10 ? '0'+(date.getMonth()+1) : date.getMonth()+1) + '-';
                var D = date.getDate() + ' ';
                return Y+M+D;
            }
        }
    }
</script>

<style scoped lang="less">
    @import '../../assets/less/common.less';

    .joinMessage {
        background: @font-primary;
        width: @width;
        height: 154px;
        .border-radius(9px);
        .box-shadow;
        .box-sizing;
        padding: 5% 4%;
        margin-bottom: 5%;
        p {
            line-height: 2rem;
            font-size: @font;
            span {
                color: @word;
                margin-right: 3%;
            }
            i {
                color: @brick_red;
            }
        }
    }



</style>
